/**
 * workflowDisplay.ts — SDK WorkflowDisplayPayload 契约（TS）
 *
 * 职责：
 *     对齐 langchain_agentx WorkflowDisplayPayload；结构事件 data.display 类型。
 *
 * 链路位置：
 *     workflowContainerProjector → WorkflowChrome（P2+）。
 *
 * 当前裁剪范围：
 *     只读消费；不计算 display（由 SDK enricher 注入）。
 */

export type WorkflowDisplayScope =
  | 'workflow'
  | 'stage'
  | 'item'
  | 'branch'
  | 'aggregate'
  | 'subworkflow';

export type WorkflowDisplayStatus =
  | 'pending'
  | 'running'
  | 'completed'
  | 'failed'
  | 'skipped'
  | 'cancelled'
  | 'blocked'
  | 'retrying';

/** 对齐 SDK display_resolver.WorkflowDisplayPayload */
export interface WorkflowDisplayPayload {
  version?: number;
  scope?: WorkflowDisplayScope;
  title?: string;
  description?: string;
  workflow_title?: string;
  workflow_description?: string;
  parent_title?: string;
  breadcrumb?: string[];
  progress_current?: number;
  progress_total?: number;
  progress_label?: string;
  progress_indeterminate?: boolean;
  status?: WorkflowDisplayStatus;
  status_reason?: string;
  icon?: string;
  item_index?: number;
  item_total?: number;
  metrics_completed?: number;
  metrics_running?: number;
  metrics_failed?: number;
  metrics_total?: number;
  decision_label?: string;
  pattern?: string;
  debug_key?: string;
}

export function readDisplayPayload(data: Record<string, unknown>): WorkflowDisplayPayload | null {
  const display = data.display;
  if (display != null && typeof display === 'object' && !Array.isArray(display)) {
    return display as WorkflowDisplayPayload;
  }
  return null;
}
